import httpService from "../Api/http.service";
import { getApiBaseUrl } from 'utils';

const getTrendsBaseUrl = () => `${getApiBaseUrl()}/subv2/subscriptions/trends`;

const getUpcomingRenewals = (payload) =>
  httpService({
    url: getTrendsBaseUrl() + `/renewal-upcoming?${payload}`,
    method: "get",
  });

const getRetentionDetails = (payload) =>
  httpService({
    url: getTrendsBaseUrl() + `/retention?${payload}`,
    method: "get",
  });

const getStatsDetails = (payload) =>
  httpService({
    url: getTrendsBaseUrl() + `/stats?${payload}`,
    method: "get",
  });

const trendService = {
  getUpcomingRenewals,
  getRetentionDetails,
  getStatsDetails,
};

export default trendService;
